import { render, staticRenderFns } from "./batchreport.vue?vue&type=template&id=57afd92c&scoped=true&"
import script from "./batchreport.vue?vue&type=script&lang=js&"
export * from "./batchreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57afd92c",
  null
  
)

export default component.exports